module.exports = __webpack_public_path__ + "img/video.a6e1473b.jpg";